/* "Added to cart", loaded on every page by the dialog snippet that
   layout/theme.liquid renders. Enhances every server-rendered cart form on
   the page through one delegated submit listener: the product page buy box
   form (#stoklink-buybox-form; the answer strip and the mobile bar submit
   it through their form attribute), the one-click "Add to cart" forms of
   the product rows (comparable, related, recently viewed, ladder), the
   collection, search, 404, article and home rows, the hub rows, the series
   ladder and the home hero deals, also rows inserted later by scripts.

   - On submit the form data goes to /cart/add.js with
     sections=stoklink-cart-added, so the response carries that section
     rendered with the updated cart. The line whose key the response names
     is kept, the others are dropped, and the dialog opens on the page: the
     added line, the cart summary, View cart / Continue shopping. The
     header count and its label are updated.
   - A 422 (Shopify refused the add, e.g. more than the stock) opens the
     dialog in its error state with Shopify's description.
   - A network failure falls back to a normal submit, which shows the cart
     page as before. Without <dialog>, fetch or FormData nothing is
     intercepted.
   - While the request runs every submit button of the form reads the busy
     label and is disabled. Close: buttons, backdrop click, Esc (native);
     focus returns to the button that submitted. The scroll lock is CSS
     (scroll-lock attribute, html:has(dialog[scroll-lock][open]) in
     critical.css). */
(function () {
  'use strict';

  var dialog = document.querySelector('[data-cart-added]');
  if (!dialog) return;
  if (typeof dialog.showModal !== 'function' || !window.fetch || !window.FormData) return;

  var slot = dialog.querySelector('[data-cart-added-slot]');
  var addUrl = dialog.getAttribute('data-add-url') || '/cart/add';
  var sectionId = dialog.getAttribute('data-section') || 'stoklink-cart-added';
  var busyLabel = dialog.getAttribute('data-busy-label') || '';
  var countLabel = dialog.getAttribute('data-count-label') || '';
  var genericError = dialog.getAttribute('data-error-text') || '';
  var busy = false;
  var lastTrigger = null;
  var pressedBackdrop = false;

  function focusElement(el) {
    if (!el || typeof el.focus !== 'function') return;
    try {
      el.focus({ preventScroll: true });
    } catch (error) {
      el.focus();
    }
  }

  function submitButtons(form) {
    /* form.id would be the hidden <input name="id"> (named-item access),
       so the id attribute is read as a string. */
    var id = form.getAttribute('id');
    var inside = [].slice.call(form.querySelectorAll('button[type="submit"]'));
    var outside = id ? [].slice.call(document.querySelectorAll('button[form="' + id + '"]')) : [];
    return inside.concat(outside);
  }

  function setBusy(form, on) {
    busy = on;
    submitButtons(form).forEach(function (button) {
      if (on) {
        if (!button.hasAttribute('data-idle-label')) button.setAttribute('data-idle-label', button.textContent);
        if (busyLabel) button.textContent = busyLabel;
        button.disabled = true;
        button.setAttribute('aria-busy', 'true');
      } else {
        if (button.hasAttribute('data-idle-label')) button.textContent = button.getAttribute('data-idle-label');
        button.disabled = false;
        button.removeAttribute('aria-busy');
      }
    });
  }

  function updateHeader(count) {
    /* Header and answer strip both carry a cart link with a count. */
    [].slice.call(document.querySelectorAll('[data-cart-count]')).forEach(function (counter) {
      counter.textContent = String(count);
      counter.hidden = count === 0;
    });
    if (!countLabel) return;
    [].slice.call(document.querySelectorAll('[data-cart-link]')).forEach(function (link) {
      link.setAttribute('aria-label', countLabel.replace('[count]', String(count)));
    });
  }

  function show(state, content) {
    dialog.setAttribute('data-cart-added-state', state);
    slot.innerHTML = '';
    if (content) slot.appendChild(content);
    if (!dialog.open) dialog.showModal();
    focusElement(dialog.querySelector('[data-cart-added-continue]') || dialog.querySelector('[data-cart-added-close]'));
  }

  function showError(message) {
    var p = document.createElement('p');
    p.className = 'cart-added__error';
    p.textContent = message || genericError;
    show('error', p);
  }

  function showAdded(json) {
    var html = json && json.sections && json.sections[sectionId];
    var body = null;
    if (html) {
      var template = document.createElement('template');
      template.innerHTML = html;
      body = template.content.querySelector('[data-cart-added-body]');
    }
    if (!body) {
      show('success', null);
      return;
    }
    var key = json.key || '';
    var lines = [].slice.call(body.querySelectorAll('[data-cart-added-line]'));
    lines.forEach(function (line) {
      if (line.getAttribute('data-cart-added-line') === key) {
        line.hidden = false;
      } else {
        line.parentNode.removeChild(line);
      }
    });
    updateHeader(parseInt(body.getAttribute('data-count'), 10) || 0);
    show('success', body);
  }

  function close() {
    if (dialog.open) dialog.close();
  }

  function isCartForm(form) {
    if (!form || form.nodeName !== 'FORM') return false;
    var action = form.getAttribute('action') || '';
    return action.indexOf('/cart/add') !== -1;
  }

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (event.defaultPrevented || !isCartForm(form)) return;
    event.preventDefault();
    if (busy) return;
    lastTrigger = event.submitter || null;
    var data = new FormData(form);
    data.append('sections', sectionId);
    data.append('sections_url', window.location.pathname);
    setBusy(form, true);
    fetch(addUrl + '.js', {
      method: 'POST',
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: data
    })
      .then(function (response) {
        return response.json().then(
          function (json) {
            return { ok: response.ok, json: json };
          },
          function () {
            return { ok: response.ok, json: null };
          }
        );
      })
      .then(function (result) {
        setBusy(form, false);
        if (!result.ok) {
          var json = result.json || {};
          showError(json.description || json.message || '');
          return;
        }
        showAdded(result.json);
      })
      .catch(function () {
        setBusy(form, false);
        form.submit();
      });
  });

  dialog.addEventListener('pointerdown', function (event) {
    pressedBackdrop = event.target === dialog;
  });

  dialog.addEventListener('click', function (event) {
    var target = event.target;
    if (target && typeof target.closest === 'function' && target.closest('[data-cart-added-close]')) {
      close();
      return;
    }
    if (target === dialog && pressedBackdrop) close();
    pressedBackdrop = false;
  });

  dialog.addEventListener('close', function () {
    pressedBackdrop = false;
    if (lastTrigger && document.contains(lastTrigger)) focusElement(lastTrigger);
    lastTrigger = null;
  });
})();
